import { GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields";
import Perdas from "..";
import TextInput from "components/form/input/TextInput";
import CheckboxInput from "components/form/input/CheckboxInput";

export function PerdasParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={Perdas.field + tipoIndicadorField}
            bottomFields={
                <>
                    <ParamFormRow label="Meta">
                        <TextInput name="mecanizado.meta" label="Meta (%)" type="number" />
                    </ParamFormRow>
                    <ParamFormRow label="Opções coleta">
                        <CheckboxInput name="mecanizado.toco" label="Toco" />
                        <CheckboxInput name="mecanizado.ponteiro" label="Ponteiro" />
                        <CheckboxInput name="mecanizado.canaInteira" label="Cana Inteira" />
                        <CheckboxInput name="mecanizado.canaFixa" label="Cana Fixa" />
                        <CheckboxInput name="mecanizado.estilhaco" label="Estilhaço" />
                        <CheckboxInput name="mecanizado.tolete" label="Tolete" />
                        <CheckboxInput name="mecanizado.pedaco" label="Pedaço" />
                        <CheckboxInput name="mecanizado.lasca" label="Lasca" />
                        <CheckboxInput name="mecanizado.toleteEstilhacado" label="Tolete Estilhaçado" />
                    </ParamFormRow>
                </>
            }
        />
    );
}
